<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row" v-if="object">
                <div class="col-md-6">
                    <card>
                        <h4 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h4>
                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <button type="button" class="btn btn-info btn-fill btn-usage"
                                    @click.prevent="openUsage">
                                Где используется этот стикер
                            </button>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="object.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="object.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="c.id !== 999" v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="object.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Доступно для редактирования</label>
                                        <select v-model="object.no_color"
                                                id="status-control"
                                                :disabled="!isSvgSrc(object.src)"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="0">Доступно</option>
                                            <option value="1">Не доступно</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Src"
                                              v-model="object.src"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="object.sort"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-6 buttons-block">
                                    <h4 slot="header" class="card-title">
                                        Стикер: <span v-if="object.src">
                                            <span class="inline-link">
                                                <span v-if="object.src_size >= 1"
                                                      class="bg-danger">{{ object.src_size }}Mb</span>
                                                <span v-else-if="object.src_size >= 0.5"
                                                      class="bg-warning">{{ object.src_size }}Mb</span>
                                                <span v-else>{{ object.src_size }}Mb</span>
                                                <a :href="object.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h4>

                                    <img @click.prevent="openResource(object.src_full)"
                                         :src="object.src_full" class="device-block device1">

                                    <div>
                                        <input ref="imageFileInput" class="btn-file" type="file"
                                               accept=".gif,.svg,.png,.jpg,.jpeg,.webp,image/gif,image/svg+xml,image/png,image/jpeg,image/webp"
                                               @change="uploadFile($event, 'object_src')">
                                        <button type="button" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.imageFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <div class="btn btn-danger btn-fill float-left btn-save"
                                     @click="remove()">
                                    Удалить
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!object.sort || !object.category_id || !object.src"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>

        <div class="modal-mask" v-if="show_usage_modal" @click="closeUsage">
            <div class="modal-wrapper">
                <div class="modal-container" @click.stop>
                    <div class="modal-header">
                        <h4 class="card-title">Где используется этот стикер</h4>
                        <button type="button" class="btn btn-default btn-fill btn-close-modal" @click="closeUsage">
                            Закрыть
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="usage-loader" v-if="usage_loading"></div>

                        <div v-if="!usage_loading && !usage.templates.length && !usage.carousels.length"
                             class="usage-empty">
                            Этот стикер нигде не используется
                        </div>

                        <div v-if="!usage_loading && usage.templates.length">
                            <h5 class="usage-section-title">Шаблоны <span>{{ usage.templates.length }}</span></h5>
                            <div class="usage-grid">
                                <div class="usage-card" v-for="item in usage.templates" :key="'t-' + item.id"
                                     @click="openTemplate(item.id)">
                                    <div class="usage-preview">
                                        <video v-if="isVideo(item.preview_src_full)" muted loop autoplay playsinline
                                               :src="item.preview_src_full"></video>
                                        <img v-else-if="item.preview_src_full" :src="item.preview_src_full" alt="">
                                        <div v-else class="usage-preview-empty">нет превью</div>
                                    </div>
                                    <div class="usage-meta">
                                        <div class="usage-id">#{{ item.id }}</div>
                                        <div class="usage-category">{{ item.category }}</div>
                                        <div class="usage-status text-primary" v-if="item.release_date">Запланировано</div>
                                        <div class="usage-status text-success" v-else-if="item.status === 1">Опубликовано</div>
                                        <div class="usage-status text-warning" v-else>Ожидает</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!usage_loading && usage.carousels.length">
                            <h5 class="usage-section-title">Карусели <span>{{ usage.carousels.length }}</span></h5>
                            <div class="usage-grid">
                                <div class="usage-card" v-for="item in usage.carousels" :key="'c-' + item.id"
                                     @click="openCarousel(item.id)">
                                    <div class="usage-preview" :class="{ 'is-square': item.ratio == 4 }">
                                        <img v-if="item.preview_src_full" :src="item.preview_src_full" alt="">
                                        <div v-else class="usage-preview-empty">нет превью</div>
                                    </div>
                                    <div class="usage-meta">
                                        <div class="usage-id">#{{ item.id }}</div>
                                        <div class="usage-category">{{ item.category }}</div>
                                        <div class="usage-status text-success" v-if="item.status === 1">Активен</div>
                                        <div class="usage-status text-warning" v-else>Не активен</div>
                                        <div class="usage-parts" v-if="item.parts && item.parts.length">
                                            слайды: {{ item.parts.join(', ') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import previewBackLink from 'src/mixins/previewBackLink'

export default {
    mixins: [previewBackLink],
    name: 'EditAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            object: null,
            originalStatus: null,
            categories: [],
            show_usage_modal: false,
            usage_loading: false,
            usage: {
                templates: [],
                carousels: []
            },
        }
    },
    created: function () {
        this.id = this.$route.params.id;
        this.getCategories();
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
    },
    methods: {
        // back to the preview if the page was opened from it, otherwise to the list
        goBack: function () {
            this.leaveTo('/graphics');
        },
        isSvgSrc: function (src) {
            if (!src || typeof src !== 'string') {
                return false;
            }

            return /\.svg$/i.test(src.split('?')[0]);
        },
        isVideo: function (url) {
            return url && url.indexOf('.mp4') > -1;
        },
        pluralize: function (n, one, few, many) {
            const num = Math.abs(parseInt(n, 10)) || 0;
            const mod100 = num % 100;
            const mod10 = num % 10;

            if (mod100 > 10 && mod100 < 20) {
                return many;
            }

            if (mod10 === 1) {
                return one;
            }

            if (mod10 >= 2 && mod10 <= 4) {
                return few;
            }

            return many;
        },
        usageCountText: function (templates, carousels) {
            return `${templates} ${this.pluralize(templates, 'шаблоне', 'шаблонах', 'шаблонах')} и ${carousels} ${this.pluralize(carousels, 'карусели', 'каруселях', 'каруселях')}`;
        },
        updatedCountText: function (templates, carousels) {
            return `Обновлено: ${templates} ${this.pluralize(templates, 'шаблон', 'шаблона', 'шаблонов')}, ${carousels} ${this.pluralize(carousels, 'карусель', 'карусели', 'каруселей')}`;
        },
        openUsage: function () {
            let self = this;

            self.show_usage_modal = true;
            self.usage_loading = true;
            self.usage = {
                templates: [],
                carousels: []
            };

            axios.get(
                `${this.$hostname}/admin/graphics/${this.id}/usage`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {
                    let data = JSON.parse(JSON.stringify(response.data)) || {};
                    self.usage = {
                        templates: data.templates || [],
                        carousels: data.carousels || []
                    };
                    self.usage_loading = false;
                })
                .catch(function (error) {
                    self.usage_loading = false;
                    self.show_usage_modal = false;

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        closeUsage: function () {
            this.show_usage_modal = false;
        },
        openTemplate: function (id) {
            const routeData = this.$router.resolve({
                name: 'edit-template',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        openCarousel: function (id) {
            const routeData = this.$router.resolve({
                name: 'edit-post',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        getCategories: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/graphics/categories`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.categories = JSON.parse(JSON.stringify(response.data));

                    self.get(self.id);
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/graphics/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.object = JSON.parse(JSON.stringify(response.data));
                    self.originalStatus = self.object.status;

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        fetchUsageCounts: function () {
            return axios.get(
                `${this.$hostname}/admin/graphics/${this.id}/usage`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }
            ).then(function (response) {
                const usage = (response.data) || {};

                return {
                    templates: (usage.templates || []).length,
                    carousels: (usage.carousels || []).length
                };
            });
        },
        confirmIfUsed: async function (usedActionText, emptyConfirmText) {
            const counts = await this.fetchUsageCounts();

            if (counts.templates > 0 || counts.carousels > 0) {
                return confirm(
                    `Этот стикер используется в ${this.usageCountText(counts.templates, counts.carousels)}. ${usedActionText}`
                );
            }

            if (emptyConfirmText) {
                return confirm(emptyConfirmText);
            }

            return true;
        },
        notifyError: function (message) {
            const notification = {
                template: `<span><b>${message}</b></span>`
            };

            this.$notifications.notify(
                {
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
        },
        save: async function () {
            let self = this;

            const statusDeactivated = parseInt(this.originalStatus, 10) === 1
                && parseInt(this.object.status, 10) === 0;

            if (statusDeactivated) {
                self.waiting = true;

                try {
                    const confirmed = await this.confirmIfUsed('При сохранении этот объект пропадет из этих шаблонов. Продолжить?');
                    self.waiting = false;

                    if (!confirmed) {
                        return;
                    }
                } catch (error) {
                    self.waiting = false;
                    this.notifyError(
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'Не удалось проверить использования стикера'
                    );
                    return;
                }
            }

            let graphic = JSON.parse(JSON.stringify(this.object));

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/graphics/${this.id}/update`,
                graphic,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const data = response.data || {};
                    self.originalStatus = graphic.status;

                    if (data.src) {
                        self.object.src = data.src;
                        self.object.src_full = self.graphicsUrl + data.src;
                    }

                    let message = 'Стикер был успешно обновлён';

                    if (data.usages) {
                        message += `. ${self.updatedCountText(data.usages.templates, data.usages.carousels)}`;
                    }

                    const notification = {
                        template: `<span><b>${message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    self.waiting = false;

                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        remove: async function () {
            let self = this;

            self.waiting = true;

            try {
                const confirmed = await this.confirmIfUsed(
                    'При удалении этот объект пропадет из этих шаблонов. Продолжить?',
                    'Подтверждение удаления стикера'
                );
                self.waiting = false;

                if (!confirmed) {
                    return;
                }
            } catch (error) {
                self.waiting = false;
                this.notifyError(
                    error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Не удалось проверить использования стикера'
                );
                return;
            }

            self.waiting = true;

            axios.get(
                `${this.$hostname}/admin/graphics/${this.id}/remove`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const notification = {
                        template: `<span><b>Стикер был успешно удалён</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    self.waiting = false;

                    self.leaveTo('/graphics');
                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();
            const file = event.target.files[0];

            self.waiting = true;

            if (file && !self.isSvgSrc(file.name)) {
                self.object.no_color = 1;
            }

            formData.append('file', file);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        openResource: function(url) {
            window.open(url, "_blank");
        }

    }
}

</script>
<style scoped>
.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}
.device1 {
    display: block;
    max-width: 100%;
    max-height: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
    margin-top: 15px;
    margin-bottom: 15px;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.btn.btn-usage {
    width: auto;
    margin-top: 0;
    margin-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 960px;
    max-width: 94%;
    margin: 0 auto;
    padding: 20px 24px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-header h4 {
    margin: 0;
}

.btn-close-modal {
    margin: 0;
}

.modal-body {
    margin: 16px 0 0;
    overflow: auto;
    max-height: 70vh;
    position: relative;
    min-height: 120px;
}

.usage-loader {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    min-height: 120px;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.7;
}

.usage-empty {
    padding: 40px 0;
    text-align: center;
    color: #888;
    font-size: 16px;
}

.usage-section-title {
    margin: 8px 0 14px;
    font-weight: 600;
}

.usage-section-title span {
    display: inline-block;
    min-width: 22px;
    padding: 1px 7px;
    margin-left: 6px;
    border-radius: 10px;
    background: #e8eef5;
    font-size: 13px;
    color: #4a5a6a;
}

.usage-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 24px;
}

.usage-card {
    width: 150px;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
    background: #fff;
}

.usage-card:hover {
    border-color: #54abfe;
    box-shadow: 0 2px 8px rgba(84, 171, 254, 0.2);
}

.usage-preview {
    position: relative;
    width: 100%;
    height: 170px;
    background: #f4f6f8;
    border-radius: 6px;
    overflow: hidden;
}

.usage-preview img,
.usage-preview video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.usage-preview.is-square {
    height: auto;
    aspect-ratio: 1 / 1;
}

.usage-preview.is-square img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
}

.usage-preview-empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
}

.usage-meta {
    margin-top: 8px;
}

.usage-id {
    font-weight: 600;
    font-size: 14px;
}

.usage-category,
.usage-parts {
    font-size: 12px;
    color: #777;
    line-height: 1.3;
}

.usage-status {
    font-size: 12px;
    font-weight: 600;
    margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Graphics/Edit.vue